<template>
  <div class="allDeviceIndex">
    <div class="headChartWarp">
      <keep-alive>
        <deviceListMapTem ref="maps" :height="height" :have-location-info="haveLocationInfo" :is-show-g-d-map="map == 'gdMap'"
          :is-show-map-float="isShowMapFloat" :center-marker-info="centerMarkerInfo" @getCenterMcuid="getCenterMcuid"
          @fullScreen="fullScreen" />
      </keep-alive>
    </div>
    <div ref="TableWarpBox" class="tableWarp" :style="tableStyle" @scroll="scrollHandle">

      <div class="flex_bet input_list" :style="inputBoxStyle">
        <!-- 公司选择 -->
        <div class="flex_row flex_align_center">
          <el-input v-model.trim="tableObj.deviceName" :placeholder="$t('AllDevices.SearchDeviceNameOrSn')" clearable
            @clear="changeSearch" @change="changeSearch" style="width: 220px; margin-right: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
          </el-input>
          <search-company v-model="selectCompany2" @change="changeSearch" style="width: 180px;"></search-company>
          <el-autocomplete v-model="tableObj.site" :fetch-suggestions="querySearchCity"
            :placeholder="$t('dashboard.SiteName')" clearable @clear="changeSearch" @select="changeSearch"
            style="margin: 0 10px; width: 180px;">
            <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
          </el-autocomplete>
          <el-select v-if="$store.state.companyId==4" v-model="tableObj.showAll" :placeholder="$t('location.device')"
            clearable @change="changeSearch" style="margin-right: 10px;">
            <el-option v-for="(item,index) in showAllOptions" :key="index" :label="item.label" :value="item.key" />
          </el-select>
          <!-- 排序方式 -->
          <template v-if="activeDevice=='Yhub'||activeDevice=='Lithium'">
            <el-select v-model="tableObj.sortType" :placeholder="$t('adminView.Sort')" clearable filterable
              @change="changeSearch('sortType')" style="width: 120px; margin-right: 10px;">
              <el-option v-for="(item,index) in sortTypeOptions" :key="index" :label="item.label" :value="item.key" />
            </el-select>
            <div>
              <div class="topArrow sortArrow" :class="{'activeArrow':tableObj.sxDxType==2&&tableObj.sortType!=0}"
                @click="changeSort(2)" />
              <div class="bottomArrow sortArrow" :class="{'activeArrow':tableObj.sxDxType==1&&tableObj.sortType!=0}"
                @click="changeSort(1)" />
            </div>
          </template>

        </div>
        <div>
          <el-button v-if="$store.state.isAdmin" icon="el-icon-download" :title="$t('adminView.DownloadSIM')"
            type="primary" @click="download" />
          <el-button v-if="$store.state.companyId!=134&&$store.state.userInfo.guestFlag!=true" icon="el-icon-plus"
            :title="$t('titles.addDevice')" type="primary" @click="addBind" />
        </div>
      </div>

      <!-- <el-tabs v-model="activeDevice" type="border-card"> -->
      <!-- <p v-if="!isShowYHUB&&!isShowLithium&&!isShowContro">{{ $t('yhubReport.Nodata') }}</p> -->
      <!-- yhub -->
      <!-- <el-tab-pane v-if="isShowYHUB" :label="$t('AllDevices.BatteryMonitor')" name="Yhub" style="position:relative;"> -->

      <div class="table_box">
        <table v-loading="isShowLoading" border="1" class="myTable">
          <tr>
            <th>{{ $t('dashboard.DeviceName') }}</th>
            <th>{{ $t('basicinfo.BindingTime') }}</th>
            <th>{{ $t('allDeviceDetail.MonitoringDuration') }}</th>
            <th v-if="haveChildCompany">{{ $t('BondOrUpdateDevice.OwnedCompany') }}</th>
            <th>{{ $t('allDeviceDetail.FirmwareVersiongo') }}</th>
            <th>{{ $t('AllDevices.Realtimedata') }}</th>
            <th>{{ $t('dashboard.LatestUpdate') }}</th>
            <th v-if="$store.state.companyId!=134">
              <span>{{ $t('yhubReport.Operating') }}</span>
              <div class="el-icon-unlock" :title="$t('titles.moreBtn')" style="cursor: pointer;"
                @click="openunLock('Yhub')" />
            </th>
          </tr>
          <tr v-for="(yhub,index) in yhubTableData" :key="index">
            <td >
              <div class="status_icon_box flex_align_center">
                <i class="iconfont icondingwei3 active click"
                v-if="(centerMcuid&&yhub.mcuId == centerMcuid) ||(yhub.lon&&(yhub.locationStatus||isAdmin))"
                @click="clickLocation(yhub, (centerMcuid&&yhub.mcuId == centerMcuid) ||(yhub.lon&&(yhub.locationStatus||isAdmin)))" />
                <!-- 在线图标 -->
                <span v-if="yhub.onlineStatus" class="online_tag">online</span>
              </div>
              

              <el-link @click="goToDetail(yhub)"
                type="primary">{{ yhub.deviceName || '(' + yhub.deviceSn + ')' }}</el-link>

            </td>
            <td>{{ yhub.bindTimeZh }}</td>
            <!-- 持续监控 -->
            <td>{{ yhub.resetTime | timeHandler }}</td>
            <td v-if="haveChildCompany">{{ yhub.OwnedCompany||'--' }}</td>
            <td> {{ yhub.fwVersion? 'V' + yhub.fwVersion : '--' }} </td>
            <td class="flex_around real_item">
              <div>
                <img v-if="yhub.lastRecordData&&yhub.lastRecordData.currentCharging>0" alt
                  src="@/assets/icon/charging1.gif" class="soc">
                <img v-else-if="yhub.lastRecordData&&yhub.lastRecordData.currentUsing>0" alt
                  src="@/assets/icon/discharging1.gif" class="soc">
                <img v-else src="@/assets/icon/idel1.png" class="soc">
                <p>SOC</p>
                <p v-if="!yhub.soc&&yhub.soc!=0" class="infoP">--</p>
                <p v-else :style="{color:yhub.soc<=30?'red':''}" class="infoP">{{ yhub.soc }}%</p>
              </div>
              <div>
                <img src="@/assets/icon/voltage.png">
                <p>{{ $t('basicinfo.Voltage') }}</p>
                <p v-if="yhub.voltageRaw||yhub.voltageRaw==0" class="infoP">{{ yhub.voltageRaw/100 }}V</p>
                <p v-else class="infoP">--</p>
              </div>
              <div>
                <img src="@/assets/icon/waterBlack.png">
                <p>{{ $t('warningPage.Level') }}</p>
                <p v-if="yhub.level=='-1'" class="infoP">{{ $t('allDeviceDetail.NotInstalled') }}</p>
                <p v-if="yhub.level===0" class="infoP" style="color:red;">{{ $t('allDeviceDetail.Bad') }}</p>
                <p v-if="yhub.level=='1'" class="infoP">{{ $t('allDeviceDetail.Normal') }}</p>
                <p v-if="!yhub.level&&yhub.level!='0'" class="infoP">--</p>
              </div>
              <div>
                <img src="@/assets/icon/tBlack.png">
                <p>{{ $t('warningPage.temperature') }}</p>
                <p v-if="yhub.batteryTemperature<'-20'" class="infoP">{{ $t('allDeviceDetail.NotInstalled') }}
                </p>
                <p v-else-if="yhub.batteryTemperature>=120" class="infoP">
                  {{ $t('basicinfo.AbnormalTemperature') }}</p>
                <p v-else-if="!yhub.batteryTemperature&&yhub.batteryTemperature!=0" class="infoP">--</p>
                <p v-else class="infoP">{{ Math.round(yhub.batteryTemperatureS) }} {{ unit }}</p>
              </div>
            </td>
            <td>{{ yhub.updateTime }}</td>
            <td v-if="$store.state.companyId!=134" class="btn_box">
              <el-button v-if="openYhubunLock&&$store.state.userInfo.guestFlag!=true" icon="el-icon-edit"
                :title="$t('titles.editConfig')" size="mini" type="primary" @click="yhubEdit(yhub)" />
              <el-button icon="el-icon-data-line" :title="$t('titles.toReport')" size="mini" type="primary"
                @click="goToReport(yhub)" />
              <el-button v-if="openYhubunLock" size="mini" type="primary" :title="$t('titles.bleDetail')"
                @click="goToBleYhub(yhub)">
                <img src="../../assets/icon/ble.png" alt="" style="width: 12px;">
              </el-button>

              <el-button type="primary" size="mini" class="el-icon-view" :title="$t('titles.toWeekReport')"
                style="vertical-align: top;" @click="toWeekReport('Yhub', yhub)" />

              <!-- <el-button v-if="openYhubunLock" type="primary" size="mini" icon="el-icon-menu" @click="goToSocDetail(yhub)" /> -->
              <el-button v-if="openYhubunLock&&$store.state.userInfo.guestFlag!=true" icon="el-icon-unlock"
                :title="$t('titles.unbindDevice')" size="mini" type="primary" @click="unLock(yhub)" />
            </td>
          </tr>
        </table>
        <!-- 列表模块————分页 -->

        <el-pagination v-if="pageshow1" :page-size="listQuery1.pageInfo.limit"
          :page-sizes="listQuery1.pageInfo.pageList" :total="listQuery1.pageInfo.total" background
          current-page.sync="listQuery1.pageInfo.page" layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange1" @size-change="handleSizeChange1" style="margin-top: 20px;" />

      </div>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog id="addDevicePop" :close-on-click-modal="false" :visible.sync="addDevicePop" width="80%" top="10vh"
      @close="closePop('addDevicePop')">
      <addDeviceTem :company-options="companyOptions" :is-show-add-device-pop="addDevicePop" :options2="options2"
        :machine-type-options="machineTypeOptions" :active-device-type="selectDeviceType" :can-funtion="canFuntion"
        @closeAddPopClick="closeAddPopClick" />
    </el-dialog>
    <!-- 编辑配置信息弹窗 -->
    <el-dialog id="editDevicePop" :close-on-click-modal="false" :visible.sync="editDevicePop" width="80%" top="5vh"
      @close="closePop('editDevicePop')">
      <!-- <el-row :gutter="40"> -->
      <!--其他设置-->
      <el-tabs v-model="activeSetOrCal" style="margin-top:15px;" type="border-card">
        <el-tab-pane :label="$t('BondOrUpdateDevice.Advanced')" name="set" style="position:relative;" />
        <el-tab-pane v-if="activeDevice=='Yhub'||activeDevice=='Lithium'" :label="$t('AllDevices.Calibrate')"
          name="calibration" style="position:relative;" />
        <div v-if="activeSetOrCal=='set'">
          <!-- 高级配置 -->
          <configSetTem :select-row="selectRow" :options2="options2" @closePopClick="closePopClick"
            @openRestorePop="openRestorePop" @openConfigStatuPop="openConfigStatuPop" />
        </div>
        <div v-if="activeSetOrCal=='calibration'">
          <!-- 校准弹窗 -->
          <calibrationTem :last-record-obj="lastRecordData" :mcu-id="selectRow.mcuId"
            @calibrationClick="calibrationClick" />
        </div>
      </el-tabs>
    </el-dialog>
    <!--恢复出厂设置弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="restoreFactorySetPop" width="60%">
      <el-form ref="restoreFactorySetPop" :inline="true" :model="restoreFactorySetInfo" :rules="rules1"
        label-position="right" label-width="150px">
        <el-row :gutter="40">
          <el-col :lg="24" :sm="24" :xs="24" class="">
            <el-form-item :label="$t('BondOrUpdateDevice.Passcode')" prop="passcode">
              <el-input v-model="restoreFactorySetInfo.passcode" :placeholder="$t('BondOrUpdateDevice.EnterNumbers')"
                @blur="blurPasscode" @input="change($event)" />
              <p>{{ findPC }}</p>
              <p v-show="isShowResFacSetInfoPasscode" class="redWarningFont">
                {{ $t('BondOrUpdateDevice.IncorrectPasscode') }}</p>
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="">
            <el-form-item style="text-align: end;float: right;">
              <el-button @click="restoreFactorySetPop = false">{{ $t('button.Cancel') }}</el-button>
              <!---->
              <el-button class="" type="primary" @click="submitRestoreFactorySet('editBasicinfoPop')">
                {{ $t('button.Submit') }}</el-button>
              <!---->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!--待更改的配置弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="configStatuPop" width="60%" class="configStatuPop"
      style="margin-top:-7vh;">
      <p style="margin-bottom: 10px;">{{ $t('AllDevices.wait') }}</p>
      <el-table :data="nowAndNewConfigData" style="width: 100%" border class="simTable">
        <el-table-column prop="name" :label="$t('sim.Attributes')" align="center" />
        <el-table-column prop="value1" :label="$t('AllDevices.CurrentSet')" align="center" />
        <el-table-column prop="value2" :label="$t('AllDevices.waitUpdate')" align="center" />
      </el-table>
    </el-dialog>
    <!-- 校准弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowCalibration" class="calibrationDialog" width="80%"
      style="position:relative;z-index:999999;">
      <el-row v-if="calObj.key=='chargedah'||calObj.key=='usedah'||calObj.key=='chargingWh'||calObj.key=='usingWh'"
        :gutter="40" class="chargeDisWarp">
        <div class="chargeDisBox">
          <el-col :lg="10" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.now') }}{{ $t('QR.ChargedAH') }} ：</span>
            <span>{{ calObj.obj.chargedah }} Ah</span>
          </el-col>
          <el-col :lg="14" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.set') }}{{ $t('QR.ChargedAH') }} ：</span>
            <el-input v-model="calObj.chargedahNew" :placeholder="$t('warningSet.Pleaseenter')"
              @input="change($event)" /> Ah
          </el-col>
        </div>
        <div class="chargeDisBox">
          <el-col :lg="10" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.now') }}{{ $t('QR.dishargedAH') }} ：</span>
            <span>{{ calObj.obj.usedah }} Ah</span>
          </el-col>
          <el-col :lg="14" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.set') }}{{ $t('QR.dishargedAH') }} ：</span>
            <el-input v-model="calObj.usedahNew" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
            Ah
          </el-col>
        </div>
        <div class="chargeDisBox">
          <el-col :lg="10" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.now') }}{{ $t('basicinfo.Charged') }}：</span>
            <span>{{ calObj.obj.chargingWh }} kWh</span>
          </el-col>
          <el-col :lg="14" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.set') }}{{ $t('basicinfo.Charged') }}：</span>
            <el-input v-model="calObj.chargingWhNew" :disabled="!$store.state.isAdmin"
              :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" /> kWh
          </el-col>
        </div>
        <div class="chargeDisBox" style="border:none;">
          <el-col :lg="10" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.now') }}{{ $t('basicinfo.DisCharged') }} ：</span>
            <span>{{ calObj.obj.usingWh }} kWh</span>
          </el-col>
          <el-col :lg="14" :sm="24" :xs="24" class=" attr">
            <span>{{ $t('tagInput.set') }}{{ $t('basicinfo.DisCharged') }} ：</span>
            <el-input v-model="calObj.usingWhNew" :disabled="!$store.state.isAdmin"
              :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" /> kWh
          </el-col>
        </div>
        <el-col :lg="24" :sm="24" :xs="24" class=" btnWarp">
          <el-button @click="isShowCalibration=false">{{ $t('button.Cancel') }}</el-button>
          <el-button class="" type="primary" :disabled="calSubmitBtn" @click="calSubmit">
            {{ $t('button.Submit') }}</el-button>
        </el-col>
      </el-row>
      <el-row v-else :gutter="40" class="">
        <div>
          <div class="calBox">
            <div class="attr">{{ $t('tagInput.now') }}{{ calObj.attr }} ：</div>
            <div class="currentVal">
              <span v-if="calObj.key!='relayStatus'">{{ calObj.currentValZh }}</span>
              <el-radio v-if="calObj.key=='relayStatus'" v-model="calObj.currentVal" :disabled="true" :label="0"
                @change="change($event)">{{ $t('AllDevices.Open') }}</el-radio>
              <el-radio v-if="calObj.key=='relayStatus'" v-model="calObj.currentVal" :disabled="true" :label="1"
                @change="change($event)">{{ $t('AllDevices.Close') }}</el-radio>
              <span class="unit"> {{ calObj.unit }}</span>
            </div>
            <div v-if="calObj.key=='relayStatus'&&calObj.currentVal==1">
              <el-date-picker v-model="calObj.popStartDateOld" :disabled="true" type="datetime" size="mini"
                value-format="timestamp" :placeholder="$t('AllDevices.startDate')" />
              <span>{{ $t('AllDevices.to') }}</span>
              <el-date-picker v-model="calObj.popEndDateOld" :disabled="true" type="datetime" size="mini"
                value-format="timestamp" :placeholder="$t('AllDevices.endDate')" />
            </div>
          </div>
          <div class="calBox">
            <div class="attr">{{ $t('tagInput.set') }}{{ calObj.attr }} ：</div>
            <div class="currentVal">
              <el-radio v-if="calObj.key=='relayStatus'" v-model="calObj.newVal" :label="0" @change="change($event)">
                {{ $t('AllDevices.Open') }}</el-radio>
              <el-radio v-if="calObj.key=='relayStatus'" v-model="calObj.newVal" :label="1" @change="change($event)">
                {{ $t('AllDevices.Close') }}</el-radio>
              <el-input v-if="calObj.key!='relayStatus'" v-model="calObj.newVal"
                :disabled="calObj.key=='current'||calObj.key=='auxCurrent'" :placeholder="$t('warningSet.Pleaseenter')"
                @input="change($event)" />
              <span class="unit"> {{ calObj.unit }}</span>
            </div>
            <div v-if="calObj.key=='relayStatus'&&calObj.newVal==1">
              <el-date-picker v-model="calObj.popStartDate" type="datetime" size="mini" value-format="timestamp"
                :placeholder="$t('AllDevices.startDate')" />
              <span>{{ $t('AllDevices.to') }}</span>
              <el-date-picker v-model="calObj.popEndDate" type="datetime" size="mini" value-format="timestamp"
                :placeholder="$t('AllDevices.endDate')" />
            </div>
          </div>
          <el-col :lg="24" :sm="24" :xs="24" class=" attr" style="text-align: center;position: relative;z-index: 9999;">
            <el-button @click="isShowCalibration=false">{{ $t('button.Cancel') }}</el-button>
            <el-button class="" type="primary" :disabled="calSubmitBtn" @click="calSubmit">
              {{ $t('button.Submit') }}</el-button>
          </el-col>
        </div>
      </el-row>

    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  findBatteryDeviceList, findBatteryDeviceListV3, addDeviceAllReset, deleteDeviceBind, findDeviceType,
  findLithiumDeviceList, findControllerDeviceList, yhubControl, listByCompanyParentId,
  getCompanySiteList, findLithiumEVDeviceList, cascader, machineTypeList,
  download263, findLithiumEV477DeviceList
} from '@/api/allDevice'
import deviceListMapTem from '@/components/deviceListMapTem' // 高德和谷歌地图
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour, howLongAgo, howLongAgo2 } from '@/utils/updateTime.js'
import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'
import calibrationTem from './components/calibrationTem'
import configSetTem from './components/configSetTem' // 编辑配置
import addDeviceTem from './components/addDeviceTem' // 新增设备
import { temChange, temUnit } from '@/utils/temChange.js'

export default {
  name: 'DashboardAdmin',
  components: {
    deviceListMapTem, // 地图
    calibrationTem,
    configSetTem,
    addDeviceTem
  },
  filters: {
    timeHandler (val) {
      if (!val) return '--'
      return howLongAgo(val)
    }
  },
  data () {
    return {
      unit: '℃',
      height: '280px',
      isGdMap: false, //  是否显示高德地图 true：高德 false：谷歌
      locationList: [], // 地图要描点的集合
      isShowMapFloat: true, // 是否显示图示
      haveLocationInfo: true, // 是否有定位信息
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页1----end
      // 分页2----start
      listQuery2: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      // 分页----end
      // 分页3----start
      listQuery3: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow3: true,
      // 分页----end
      // 分页4----start
      listQuery4: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow4: true,
      // 分页----end
      // 分页5----start
      listQuery5: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow5: true,
      // 分页----end
      pieSeriesData: [],
      lineDate: [],
      lineHeight: '250px',
      machineNum: 0,
      pieHeight: '250px',
      companyOptions: [], // 下拉框--公司
      haveChildCompany: true, // 是否有子公司
      allCompanyArr: [], // 所有公司
      machineTypeOptions: [], // 设备类型
      column: { prop: 'dateTime', order: 'ascending' }, // el-table-column中的prop  'ascending' or 'descending',
      selectCompany: [],
      selectCompany2: [],
      tableObj: {
        // companyId: '',
        site: '',
        deviceName: '', // 删选--设备名称/sn/mcuId
        selectDate: '', // 删选--时间：bondTime/updateTime
        order: '', // 删选--排序方式：'ascending' or 'descending'
        selectCompany: [], // 删选--公司
        selectDeviceType: [], // 删选--设备类型
        sortType: '0',
        sxDxType: '1',
        showAll: 0 // 1:true 全部设备    0:false 已绑定设备
      },
      orderby: -1, // 排序
      companyId: '', // 选中的公司
      inputDevName: null, // 输入设备名称、sn
      rowTypeArr: [], // 设备类型
      selectDevice: null,
      isShowPop: false, // 弹窗--选项卡处问号
      isShowPopTable: false, // 弹窗--表格处问号
      addDevicePop: false,
      companyName: this.$store.state.companyName,
      companylistQuery: {
        pageInfo: {
          pageNum: 1,
          pageSize: 10000,
          pageNo: 1,
          total: 0,
          pageList: [10, 20, 30, 50]
        }
      },
      allDeviceSelected: true,
      // 新增设备信息弹窗----start
      addBasicinfoPop: false, // 编辑基本信息弹窗

      addBasicinfo: {
        mcuId: '',
        cell: 0,
        c520: '20',
        deviceSn: '',
        deviceName: '',
        canFuntion: '0',
        locationSample: '30',
        batterySystemVolt: null,
        batteryTotalah: null,
        supportWaterlevel: null,
        ledSetting: null,
        sensorType: null,
        hallDirection: null,
        motionTrack: null,
        supportRelaycontrol: null,
        batteryId: 2,
        configFrom: null,
        configVersion: null,
        gprsApnName: '263.cs101',
        hallSensorRange: 1,
        hourMeterStatus: false,
        openIgnitionVol: null,
        workHourmeterVol: null,
        halfV: false,
        site: ''
      },
      editing: true,
      options: null, // 电池型号
      optionsPop3: [], // 编辑设备信息弹窗--设备信息（品牌型号）下拉框
      options2: [], // 编辑设备信息弹窗--电池型号下拉框
      selectDeviceType: 'a', // 选中的设备类型
      isShowHallDetail: false,
      getLastYhubConfig: {},
      isShowSetting: false,
      isShowBatteryModelWarning: false,
      isShowOwnCompany: false,
      fwversion: null,
      isAdmin: this.$store.state.isAdmin,
      disabledSubmit: true,
      batteryModelObj: [],
      disabledC5: true,
      apnOptions: [],
      selectRow: {}, // 选中的行的数据
      // 编辑基本信息弹窗----end
      sort: 'bondTime',
      // sortDate: '',
      isShowValue: true,
      // 选项卡-----start
      activeDevice: 'Yhub',
      tabDeviceOptions: [
        { label: 'Battery Monitor', key: 'Yhub' },
        { label: 'Lithium Battery', key: 'Lithium' },
        // { label: 'GOD Charger', key: 'Charger' },
        { label: 'Controller', key: 'Controller' }
      ],
      yhubTableData: [],
      lithiumTableData: [],
      controllerTableData: [],
      eveBmsTableData: [],
      eveF477TableData: [],
      yhubLocationList: [],
      lithiumLocationList: [],
      controLocationList: [],
      eveBmsLocationList: [],
      eveF477LocationList: [],
      isShowLoading: true,
      canFuntion: 0,
      isShowYHUB: true,
      isShowLithium: true,
      isShowContro: true,
      isShowEveBms: true,
      isShowEveF477: true,
      isAdd: true,
      bindDeviceTypeArr: [], // sn绑定的设备类型
      firstAdd: true, // 首次新增，false：已存在，添加其他类型
      showBatteryModel: false, // 是否展示电池型号默认值
      oldbatterySystemVolt: '',
      oldbatteryTotalah: '',
      openYhubunLock: false,
      openLithiumunLock: false,
      openControllerunLock: false,
      openEveBmsLock: false,
      openEveF477Lock: false,
      restoreFactorySetPop: false,
      restoreFactorySetInfo: {},
      isShowResFacSetInfoPasscode: false, // 提示不能为空
      findPC: null,
      rules1: {},
      allCity: [],
      // 编辑配置信息------start
      editDevicePop: false,
      editBasicinfo: {
        c520: 20,
        batteryTotalah: '',
        batteryBrand: '',
        batteryModel: '',
        batterySystemVolt: '',
        canFuntion: '',
        configFrom: '',
        configTime: '',
        configVersion: '',
        extralFuntion: 0,
        motionTrack: '',
        communication485: '',
        currentCollection2: '',
        voltageCollection2: '',
        gprsApnKey: '',
        gprsApnName: '',
        gprsApnUser: '',
        hallDirection: '',
        hallSensorRange: '',
        isSupportPgt: '',
        isSupportRelaycontrol: '',
        isSupportWaterlevel: '',
        ledSetting: '',
        locationSample: '',
        productionData: '',
        samplingMode: 1,
        voltChangeRate: 300,
        samplingRate: 480,
        gpsFunction: 1,
        netFunction: 1,
        voltClass: 2
      },
      batteryCascader: [],
      noneConfig: false,
      isShowConfigStatu: false,
      configStatuPop: false,
      nowAndNewConfigData: [],
      activeSetOrCal: 'set',
      lastRecordData: {},
      calObj: {
        attr: null,
        currentValZh: null,
        unit: null,
        newVal: null,
        popStartDateOld: null,
        popEndDateOld: null,
        popStartDate: null,
        popEndDate: null,
        chargedahNew: null,
        usedahNew: null,
        chargingWhNew: null,
        usingWhNew: null
      },
      isShowCalibration: false,
      calSubmitBtn: true, // 校准弹窗中的提交按钮是否可编辑
      loadEditPop: false,
      isShowCellNumPop: false,
      isShowMustIntWarn: false,
      // 编辑配置信息------end
      tianMapLoadFinished: false,
      aMap: null,
      timer: null,
      centerMcuid: null,
      centerMarkerInfo: {},
      tableStyle: {},
      inputBoxStyle: {}
    }
  },
  computed: {
    ...mapState(['company', 'map']),
    language () {
      return this.$store.state.language
    },
    filterDate () {
      return [
        { text: this.$t('basicinfo.BindingTime'), value: 'bondTime' },
        { text: this.$t('dashboard.LatestUpdate'), value: 'updateTime' }
      ]
    },
    sortTypeOptions () {
      if (this.activeDevice == 'Lithium') {
        return [
          { key: '0', label: this.$t('AllDevices.DefaultSort') },
          { key: '1', label: this.$t('basicinfo.BindingTime') },
          { key: '2', label: this.$t('adminView.UpdateAt') },
          { key: '3', label: this.$t('warningPage.SOC') }
        ]
      } else {
        return [
          { key: '0', label: this.$t('AllDevices.DefaultSort') },
          { key: '1', label: this.$t('basicinfo.BindingTime') },
          { key: '2', label: this.$t('adminView.UpdateAt') },
          { key: '3', label: this.$t('warningPage.SOC') },
          { key: '4', label: this.$t('warningPage.temperature') },
          { key: '5', label: this.$t('warningPage.Level') }
        ]
      }
    },
    showAllOptions () {
      return [
        { key: 1, label: this.$t('dashboard.AllDevices') },
        { key: 0, label: this.$t('AllDevices.BondDevice') }
      ]
    },
    rules () {
      return {
        deviceName: [{ required: true, message: this.$t('allDeviceDetail.DeviceNameCannotEmpty'), trigger: 'blur' }], // 设备名称不能为空
        deviceSn: [{ required: true, message: this.$t('BondOrUpdateDevice.SNNotFound'), trigger: 'blur' }], // 序列号不能为空
        mcuId: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        passcode: [{ required: true, message: this.$t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }], // 激活码不能为空
        batteryTotalah: [{ required: true, message: this.$t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }], // 容量不能为空
        batterySystemVolt: [{ required: true, message: this.$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: 'blur' }], // 系统电压不能为空
        cell: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
        // owncompany: [{ required: true, message: '归属公司不能为空', trigger: 'change' }]
      }
    },
    editRules () {
      return {
        batteryTotalah: [{ required: true, message: this.$t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: ['blur', 'change'] }], // 容量不能为空
        batterySystemVolt: [{ required: true, message: this.$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: ['blur', 'change'] }]
      }
    }
  },
  watch: {
    language (newValue, oldValue) {
      if (this.activeDevice == 'Yhub') {
        this.yhubTableData.forEach((v) => {
          if (v.lastRecordData && v.lastRecordData.yhubStimeTs) {
            v.updateTime = howLongAgo(v.lastRecordData.yhubStimeTs)
          } // 最后更新时间
        })
      } else if (this.activeDevice == 'Lithium') {
        this.lithiumTableData.forEach((v) => {
          if (v.lastRecordData && v.lastRecordData.yhubTime) {
            v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
          } // 最后更新时间
        })
      } else if (this.activeDevice == 'Controller') {
        this.controllerTableData.forEach((v) => {
          if (v.lastRecordData && v.lastRecordData.yhubTime) {
            v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
          } // 最后更新时间
        })
      }
    },
    addBasicinfo: {
      handler (newValue, oldValue) {
        this.addBasicinfo = newValue
      },
      deep: true
    },
    activeDevice (newValue, oldValue) {
      if (newValue == 'Yhub') {
        this.canFuntion = 0
        this.selectDeviceType = 'a'
        this.yhubQueryList()
        this.$refs.maps.setMakers(this.yhubLocationList)
      } else if (newValue == 'Lithium') {
        if (this.tableObj.sortType == '4' || this.tableObj.sortType == '5') this.tableObj.sortType = '0'
        this.canFuntion = 5
        this.selectDeviceType = 'e'
        this.lithiumQueryList()
        this.$refs.maps.setMakers(this.lithiumLocationList)
      } else if (newValue == 'Controller') {
        this.canFuntion = 2
        this.selectDeviceType = 'c'
        this.controllerQueryList()
        this.$refs.maps.setMakers(this.controLocationList)
      } else if (newValue == 'EveBms') {
        this.canFuntion = 8
        this.selectDeviceType = 'i'
        this.eveBmsQueryList()
        this.$refs.maps.setMakers(this.eveBmsLocationList)
      } else if (newValue == 'EveF477') {
        this.canFuntion = 10
        this.selectDeviceType = 'j'
        this.eveF477QueryList()
        this.$refs.maps.setMakers(this.eveF477LocationList)
      }
    },
    calObj: {
      handler (newValue, oldValue) {
        if (this.calObj.key == 'chargedah' || this.calObj.key == 'usedah' || this.calObj.key == 'chargingWh' || this.calObj.key == 'usingWh') {
          if (this.existsOrZero(this.calObj.chargedahNew) && this.existsOrZero(this.calObj.usedahNew) && this.existsOrZero(this.calObj.chargingWhNew) && this.existsOrZero(this.calObj.usingWhNew)) {
            this.calSubmitBtn = false
          } else {
            this.calSubmitBtn = true
          }
        } else {
          if (this.existsOrZero(newValue.newVal)) {
            if (this.calObj.key == 'relayStatus' && this.calObj.newVal == 1) {
              if (this.calObj.popStartDate && this.calObj.popEndDate) {
                this.calSubmitBtn = false
              } else {
                this.calSubmitBtn = true
              }
            } else {
              this.calSubmitBtn = false
            }
          } else {
            this.calSubmitBtn = true
          }
        }
      },
      deep: true
    },
    $route () {
      for (var attr in this.tableObj) {
        this.tableObj[attr] = ''
        this.tableObj.selectCompany = this.tableObj.selectDeviceType = []
        this.tableObj.sortType = '0'
        this.tableObj.sxDxType = '1'
      }
      if (this.$route.query.site) {
        this.tableObj.site = this.$route.query.site;
        this.selectCompany2 = [];
        this.changeSearch()
      } else if (this.$route.query.companyId) {
        this.selectCompany2 = [Number(this.$route.query.companyId)];
        this.tableObj.site = '';
        this.changeSearch()
      } else {
        setTimeout(() => {
          this.yhubQueryList()
        }, 1000)
      }

    }
  },
  mounted () {

    if (this.$route.query.site) {
      this.tableObj.site = this.$route.query.site;
      this.selectCompany2 = [];
      this.changeSearch()
    } else if (this.$route.query.companyId) {
      this.selectCompany2 = [Number(this.$route.query.companyId)];
      this.tableObj.site = '';
      this.changeSearch()
    } else {
      setTimeout(() => {
        this.yhubQueryList()
      }, 1000)
    }
    this.findDeviceType1()
    this.listByCompanyParentId()
    this.unit = temUnit()
    this.sortTypeInt()
    this.fetchData() // 电池型号/品牌/设备类型--下拉框初始化
  },
  beforeDestroy () {
    // 销毁地图
    if (this.aMap) {
      this.aMap.destroy()
    }
  },
  methods: {
    scrollHandle (e) {
      const st = parseFloat(e.target.scrollTop.toFixed(2))
      // console.log(st)
      const hei = 300
      if (st < hei) {
        this.tableStyle = {
          paddingTop: st + 'px',
          top: (hei - st) + 'px'
        }
        this.inputBoxStyle = {
          position: 'relative',
          top: '0px'
        }
      } else {
        this.tableStyle = {
          paddingTop: hei + 'px',
          top: '0px'
        }
        this.inputBoxStyle = {
          position: 'absolute',
          top: st + 'px'
        }
      }
    },
    getCenterMcuid (val) {
      this.centerMcuid = val
    },
    clickLocation (obj, val) {
      if (!val) {
        this.$message(this.$t('allDeviceDetail.NoLocationInfo'))
        return
      }
      this.tableStyle = {
        paddingTop: '0px',
        top: '300px'
      }
      console.log('obj', obj)
      this.centerMarkerInfo = obj
      // this.setScrollBottom()
    },
    async setScrollBottom () { // 滚动条自动到顶部
      this.$nextTick(() => {
        const el = document.querySelector('.el-main')
        el.scrollTop = 0
      })
    },
    sortTypeInt () { // 排序赋值
      if (this.$store.state.allDeviceSort) {
        var sort = this.$store.state.allDeviceSort
        this.orderby = sort
        if (sort == -1) {
          this.tableObj.sortType = '0'
          this.tableObj.sxDxType = '1'
        } else {
          this.tableObj.sortType = sort.toString().split('')[0]
          this.tableObj.sxDxType = sort.toString().split('')[1]
        }
      }
    },
    fullScreen (height) {
      this.height = height
    },
    findDeviceType1 () { // 判定该用户有哪些设备类型
      findDeviceType().then((res) => {
        console.log('用户拥有的设备类型', res)
        if (res.resultCode == 1001) {
          if (res.resultModel && res.resultModel != '') {
            this.isShowYHUB = true
            if (res.resultModel.indexOf('e') > -1) {
              this.isShowLithium = true
            } else {
              this.isShowLithium = false
            }
            if (res.resultModel.indexOf('c') > -1) {
              this.isShowContro = true

            } else {
              this.isShowContro = false
            }
            if (res.resultModel.indexOf('i') > -1) {
              this.isShowEveBms = true
            } else {
              this.isShowEveBms = false
            }
            this.isShowEveF477 = res.resultModel.indexOf('j') > -1
          } else {
            this.isShowLithium = this.isShowContro = this.isShowEveBms = this.isShowEveF477 = false
          }
        }
      })
    },
    yhubQueryList () { // 选项卡--yhub初始化
      // console.log('this.selectCompany2', this.selectCompany)
      var param = {
        companyIdList: this.selectCompany,
        orderby: this.orderby,
        key: this.tableObj.deviceName,
        site: this.tableObj.site,
        showAll: this.tableObj.showAll == 1,
        displayTime: new Date().setHours(0, 0, 0, 0), // 当天零点的时间戳
        pageNum: this.listQuery1.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery1.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      // yhub
      this.isShowLoading = true
      findBatteryDeviceListV3(param).then((response) => {
        console.log('yhub设备列表', response)
        if (response.resultCode == 1001) {
          this.isShowLoading = false
          this.yhubTableData = response.resultModel.list // 设备数据
          this.listQuery1.pageInfo.total = response.resultModel.total // 分页
          this.locationList = []
          this.yhubTableData.forEach((v) => {
            v.bindTimeZh = v.resetTime ? getDateAndHour(v.resetTime, 'noTime') : '--'
            v.durationTimeZh = v.resetTime ? howLongAgo2(new Date(v.resetTime).getTime()) : '--'
            if (v.lastRecordData) {
              if (v.lastRecordData.yhubStimeTs) {
                v.updateTime = howLongAgo(v.lastRecordData.yhubStimeTs)
              } // 最后更新时间
              if (v.lastRecordData.soc || v.lastRecordData.soc == 0) {
                v.soc = Math.round(v.lastRecordData.soc / 100)
              }
              if (v.lastRecordData.voltageRaw || v.lastRecordData.voltageRaw == 0) {
                v.voltageRaw = v.lastRecordData.voltageRaw
              }
              if (v.lastRecordData.batteryTemperature || v.lastRecordData.batteryTemperature == 0) {
                v.batteryTemperature = Math.round(v.lastRecordData.batteryTemperature / 100)
                v.batteryTemperatureS = temChange(v.batteryTemperature)
              }
            }
            if (v.status == 1) {
              v.isShowWarning = true
            } else {
              v.isShowWarning = false
            }
            if (this.companyOptions.length >= 1) {
              // 有子公司
              this.allCompanyArr.forEach((m) => {
                if (v.companyId == m.id) v.OwnedCompany = m.companyName
              })
            }
            if ((v.locationStatus == 1 && v.lat) || (this.$store.state.isAdmin && v.lat)) {
              this.locationList.push(v)
            }
          })

          this.yhubLocationList = this.locationList
          this.$refs.maps.setMakers(this.locationList) // 给地图描点
        }
      })
    },
    lithiumQueryList () { // 选项卡--lithium初始化
      var param = {
        companyIdList: this.selectCompany,
        orderby: this.orderby,
        key: this.tableObj.deviceName,
        site: this.tableObj.site,
        displayTime: new Date().setHours(0, 0, 0, 0), // 当天零点的时间戳
        pageNum: this.listQuery2.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery2.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.activeDevice != 'Yhub') this.isShowLoading = true
      findLithiumDeviceList(param).then((response) => {
        // console.log(response)
        if (response.resultCode == 1001) {
          this.isShowLoading = false
          this.lithiumTableData = response.resultModel.list // 设备数据
          this.listQuery2.pageInfo.total = response.resultModel.total // 分页
          this.locationList = []
          // console.log('allChildCo
          // mpanyArr---', (this.allChildCompanyArr),
          // console.log('this.lithiumTableData---', this.lithiumTableData)
          this.lithiumTableData.forEach((v) => {
            if (v.resetTime) { // 绑定时间
              v.bindTimeZh = getDateAndHour(v.resetTime, 'noTime')
              v.durationTimeZh = howLongAgo2(new Date(v.resetTime).getTime())
            }
            if (v.lastRecordData && v.lastRecordData.yhubTime) {
              if (v.lastRecordData.yhubTime) {
                v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
              } // 最后更新时间
              if (v.lastRecordData.soc || v.lastRecordData.soc == 0) {
                // if (v.lastRecordData.soc > 10000) {
                //   v.soc = Math.round(v.lastRecordData.soc / 10000)
                // } else if (v.lastRecordData.soc > 100 && v.lastRecordData.soc <= 10000) {
                v.soc = Math.round(v.lastRecordData.soc / 100)
                // } else if ((v.lastRecordData.soc && v.lastRecordData.soc < 100) || v.lastRecordData.soc == 0) {
                //   v.soc = v.lastRecordData.soc
                // }
              }
              if (v.lastRecordData.batteryVoltage || v.lastRecordData.batteryVoltage == 0) {
                v.batteryVoltage = v.lastRecordData.batteryVoltage
              }
            }
            // if (v.createTime)v.updateTime = getDateAndHour(v.createTime)
            // v.deviceTypeT = v.deviceTypeName
            if (v.status == 1) {
              v.isShowWarning = true
            } else {
              v.isShowWarning = false
            }
            if (this.companyOptions.length >= 1) {
              // 有子公司
              this.allCompanyArr.forEach((m) => {
                if (v.companyId == m.id) v.OwnedCompany = m.companyName
              })
            }
            if ((v.locationStatus == 1 && v.lat) || (this.$store.state.isAdmin && v.lat)) {
              this.locationList.push(v)
            }
          })
          // console.log(this.yhubTableData)
          this.lithiumLocationList = this.locationList
          this.$refs.maps.setMakers(this.locationList) // 给地图描点
        }
      })
    },
    controllerQueryList () { // 选项卡--controller初始化
      var param = {
        companyIdList: this.selectCompany,
        orderby: this.orderby,
        key: this.tableObj.deviceName,
        site: this.tableObj.site,
        displayTime: new Date().setHours(0, 0, 0, 0), // 当天零点的时间戳
        pageNum: this.listQuery3.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery3.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.activeDevice != 'Yhub') this.isShowLoading = true
      findControllerDeviceList(param).then((response) => {
        // console.log(response)
        if (response.resultCode == 1001) {
          this.isShowLoading = false
          this.controllerTableData = response.resultModel.list // 设备数据
          this.listQuery3.pageInfo.total = response.resultModel.total // 分页
          this.locationList = []
          // console.log('allChildCompanyArr---', this.allChildCompanyArr)
          // console.log('this.controllerTableData---', this.controllerTableData)
          var num = 0
          this.controllerTableData.forEach((v) => {
            if (v.lastRecordData && v.lastRecordData.yhubTime) {
              v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
            } // 最后更新时间
            // if (v.createTime)v.updateTime = getDateAndHour(v.createTime)
            // v.deviceTypeT = v.deviceTypeName
            if (v.status == 1) {
              v.isShowWarning = true
            } else {
              v.isShowWarning = false
            }
            if (this.companyOptions.length >= 1) {
              // 有子公司
              this.allCompanyArr.forEach((m) => {
                if (v.companyId == m.id) v.OwnedCompany = m.companyName
              })
            }
            if (v.lat && v.lon) num++
            if ((v.locationStatus == 1 && v.lat) || (this.$store.state.isAdmin && v.lat)) {
              this.locationList.push(v)
            }
          })
          // console.log(this.yhubTableData)
          this.controLocationList = this.locationList
          // if (num == 0) { this.haveLocationInfo = false } else { this.haveLocationInfo = true }
          this.$refs.maps.setMakers(this.locationList) // 给地图描点
        }
      })
    },
    eveBmsQueryList () { // 选项卡--亿纬锂能初始化
      var param = {
        companyIdList: this.selectCompany,
        orderby: this.orderby,
        key: this.tableObj.deviceName,
        displayTime: new Date().setHours(0, 0, 0, 0), // 当天零点的时间戳
        pageNum: this.listQuery4.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery4.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.activeDevice != 'Yhub') this.isShowLoading = true
      findLithiumEVDeviceList(param).then((response) => {
        if (response.resultCode == 1001) {
          this.isShowLoading = false
          this.eveBmsTableData = response.resultModel.list // 设备数据
          this.listQuery4.pageInfo.total = response.resultModel.total // 分页
          this.locationList = []
          this.eveBmsTableData.forEach((v) => {
            if (v.lastRecordData && v.lastRecordData.jsonData && v.lastRecordData.jsonData.length > 0) {
              var jsonData = JSON.parse(v.lastRecordData.jsonData) || {}
              // console.log('jsonData', jsonData)
              if (v.lastRecordData.yhubTime) { // 最后更新时间
                v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
              }
              if (jsonData.SOC || jsonData.SOC == 0) {
                v.soc = jsonData.SOC
              }
              if (jsonData.TotalVoltage || jsonData.TotalVoltage == 0) {
                v.batteryVoltage = jsonData.TotalVoltage / 1000
              }
            }
            if (v.status == 1) {
              v.isShowWarning = true
            } else {
              v.isShowWarning = false
            }
            if (this.companyOptions.length >= 1) {
              // 有子公司
              this.allCompanyArr.forEach((m) => {
                if (v.companyId == m.id) v.OwnedCompany = m.companyName
              })
            }
            if ((v.locationStatus == 1 && v.lat) || (this.$store.state.isAdmin && v.lat)) {
              this.locationList.push(v)
            }
          })
          // console.log(this.yhubTableData)
          this.eveBmsLocationList = this.locationList
          this.$refs.maps.setMakers(this.locationList) // 给地图描点
        }
      })
    },
    eveF477QueryList () { // 选项卡--eveF477初始化
      var param = {
        companyIdList: this.selectCompany,
        orderby: this.orderby,
        key: this.tableObj.deviceName,
        displayTime: new Date().setHours(0, 0, 0, 0), // 当天零点的时间戳
        pageNum: this.listQuery4.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery4.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.activeDevice != 'Yhub') this.isShowLoading = true
      findLithiumEV477DeviceList(param).then((response) => {
        if (response.resultCode == 1001) {
          this.isShowLoading = false
          this.eveF477TableData = response.resultModel.list // 设备数据
          this.listQuery5.pageInfo.total = response.resultModel.total // 分页
          this.locationList = []
          this.eveF477TableData.forEach((v) => {
            if (v.lastRecordData && v.lastRecordData.jsonData && v.lastRecordData.jsonData.length > 0) {
              var jsonData = JSON.parse(v.lastRecordData.jsonData) || {}
              // console.log('jsonData', jsonData)
              if (v.lastRecordData.yhubTime) { // 最后更新时间
                v.updateTime = howLongAgo(v.lastRecordData.yhubTime)
              }
              if (jsonData.SOC || jsonData.SOC == 0) {
                v.soc = jsonData.SOC
              }
              if (jsonData.TotalVoltage || jsonData.TotalVoltage == 0) {
                v.batteryVoltage = jsonData.TotalVoltage / 1000
              }
            }
            if (v.status == 1) {
              v.isShowWarning = true
            } else {
              v.isShowWarning = false
            }
            if (this.companyOptions.length >= 1) {
              // 有子公司
              this.allCompanyArr.forEach((m) => {
                if (v.companyId == m.id) v.OwnedCompany = m.companyName
              })
            }
            if ((v.locationStatus == 1 && v.lat) || (this.$store.state.isAdmin && v.lat)) {
              v.updataTime = v.lastLocationTime
              this.locationList.push(v)
              // this.locationList.push({
              //   deviceName: v.deviceName,
              //   mcuId: v.mcuId,
              //   ltype: v.ltype,
              //   lat: v.lat,
              //   lon: v.lon,
              //   updataTime: v.lastLocationTime,
              //   lastLocationTime: v.lastLocationTime,
              //   status: v.status
              // })
            }
          })
          // console.log(this.yhubTableData)
          this.eveF477LocationList = this.locationList
          this.$refs.maps.setMakers(this.eveF477LocationList) // 给地图描点
        }
      })
    },
    openunLock (val) {
      if (val == 'Yhub') {
        this.openYhubunLock = !this.openYhubunLock
      } else if (val == 'Lithium') {
        this.openLithiumunLock = !this.openLithiumunLock
      } else if (val == 'Controller') {
        this.openControllerunLock = !this.openControllerunLock
      } else if (val == 'EveBms') {
        this.openEveBmsLock = !this.openEveBmsLock
      } else if (val == 'EveF477') {
        this.openEveF477Lock = !this.openEveF477Lock
      }
    },
    unLock (row) { // 解绑
      this.$confirm(this.$t('AllDevices.untie'), '', {
        // 是否确定解绑？
        confirmButtonText: this.$t('button.Confirm'), // '确定'
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          deviceType: this.selectDeviceType,
          mcuId: row.mcuId
        }
        deleteDeviceBind(param).then((res) => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted')
            })
            if (param.deviceType == 'a') {
              this.yhubQueryList()
            } else if (param.deviceType == 'e') {
              this.lithiumQueryList()
            } else if (param.deviceType == 'c') {
              this.controllerQueryList()
            } else if (param.deviceType == 'i') {
              this.eveBmsQueryList()
            } else if (param.deviceType == 'j') {
              this.eveF477QueryList()
            }
          }
        })
      }).catch(() => { })
    },
    listByCompanyParentId () { // 下拉框--客户名称
      console.log('company', this.company)
      listByCompanyParentId({
        companyParentId: this.company.id
      }).then((res) => {
        console.log('查询子公司', res)
        if (res.resultCode == 1001) {
          this.allCompanyArr = res.resultModel || []
          this.companyOptions = []
          if (res.resultModel && res.resultModel.length > 1) {
            this.haveChildCompany = true
          } else {
            this.haveChildCompany = false
          }
          res.resultModel.forEach((v) => {
            if (v.companyName) {
              this.companyOptions.push({
                companyName: v.companyName,
                companyId: v.id
              })
            }
          })
          this.companyOptionsFun()
        }
      })
    },
    companyOptionsFun () { // 将归属公司转拼音进行排序
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      this.companyOptions.forEach((v) => {
        if (v.companyName[0] >= 'a' && v.companyName[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.companyId == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          companyName: sessionCompany.companyName,
          companyId: sessionCompany.id
        })
      }
    },
    changeSort (val) {
      this.tableObj.sxDxType = val
      this.orderby = Number(this.tableObj.sortType + this.tableObj.sxDxType)
      this.$store.dispatch('setAllDeviceSort', this.orderby)
      this.changeSearch()
    },
    changeSearch () { // 筛选改变事件
      console.log(887)
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      console.log('this.selectCompany', this.selectCompany)
      if (!this.tableObj.sortType || this.tableObj.sortType == '0') {
        this.tableObj.sortType = '0'
        this.orderby = -1
        this.$store.dispatch('setAllDeviceSort', this.orderby)
      } else {
        this.orderby = Number(this.tableObj.sortType + this.tableObj.sxDxType)
        this.$store.dispatch('setAllDeviceSort', this.orderby)
      }
      if (this.activeDevice == 'Yhub') {
        this.yhubTableData = []
        this.listQuery1.pageInfo.pageNum = 1
        this.pageshow1 = false
        this.yhubQueryList()
        this.$nextTick(() => {
          this.pageshow1 = true
        })
      } else if (this.activeDevice == 'Lithium') {
        this.lithiumTableData = []
        this.listQuery2.pageInfo.pageNum = 1
        this.pageshow2 = false
        this.lithiumQueryList()
        this.$nextTick(() => {
          this.pageshow2 = true
        })
      } else if (this.activeDevice == 'Controller') {
        this.controllerTableData = []
        this.listQuery3.pageInfo.pageNum = 1
        this.pageshow3 = false
        this.controllerQueryList()
        this.$nextTick(() => {
          this.pageshow3 = true
        })
      } else if (this.activeDevice == 'EveBms') {
        this.eveBmsTableData = []
        this.listQuery4.pageInfo.pageNum = 1
        this.pageshow4 = false
        this.eveBmsQueryList()
        this.$nextTick(() => {
          this.pageshow4 = true
        })
      } else if (this.activeDevice == 'EveF477') {
        this.eveF477TableData = []
        this.listQuery5.pageInfo.pageNum = 1
        this.pageshow5 = false
        this.eveF477QueryList()
        this.$nextTick(() => {
          this.pageshow5 = true
        })
      }
    },
    goToDetail (row) { // 去设备详情页
      var routeData
      var param = {
        mcuId: row.mcuId,
        deviceType: 'a',
        sn: row.deviceSn,
        id: row.id
      }
      console.log('row********', row)
      if (this.$store.state.companyId == 4 && this.tableObj.showAll == 1 && !row.deviceName) param.showAll = 1
      if (this.activeDevice == 'Yhub') {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceDetail',
          query: param
        })
      } else if (this.activeDevice == 'Lithium') {
        param.deviceType == 'e'
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceLithiumDetail',
          query: param
        })
      } else if (this.activeDevice == 'Controller') {
        routeData = this.$router.resolve({
          path: '/allDevices/trionicDetail',
          query: {
            mcuId: row.mcuId,
            deviceType: row.deviceType,
            sn: row.deviceSn,
            id: row.id,
            deviceTypeT: row.deviceName
          }
        })
      } else if (this.activeDevice == 'EveBms') {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceEveBmsDetail',
          query: {
            mcuId: row.mcuId,
            deviceType: 'i',
            sn: row.deviceSn,
            id: row.id
          }
        })
      } else if (this.activeDevice == 'EveF477') {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceEveF477Detail',
          query: {
            mcuId: row.mcuId,
            deviceType: 'j',
            sn: row.deviceSn,
            id: row.id
          }
        })
      }
      window.open(routeData.href, '_self')
    },
    addBind () { // 新增--绑定设备弹窗--弹窗显示
      this.editing = this.isShowSetting = false
      this.addDevicePop = true
    },
    yhubEdit (row) { // 编辑配置--绑定设备弹窗--弹窗显示
      console.log(row)
      this.editDevicePop = true
      this.selectRow = row
      this.lastRecordData = row.lastRecordData ? row.lastRecordData : {}
      if (row.relayOnTime) {
        this.lastRecordData.end = row.relayOnTime.end
        this.lastRecordData.start = row.relayOnTime.start
      }
      this.activeSetOrCal = 'set'
      if (this.activeDevice == 'Lithium') {
        this.lastRecordData.chargedah = this.lastRecordData.chargingAh
        this.lastRecordData.soh = this.lastRecordData.soh / 100
        this.lastRecordData.usedah = this.lastRecordData.usedAh
        this.lastRecordData.relayStatus = this.lastRecordData.relay_Status
        this.lastRecordData.voltageRaw = this.lastRecordData.batteryVoltage
      }
    },
    toWeekReport (type, row) {
      var weekReportInfo = {}
      weekReportInfo.type = type
      weekReportInfo.startTime = new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 7
      weekReportInfo.endTime = new Date().setHours(0, 0, 0, 0) - 1000
      weekReportInfo.week = '-1'
      weekReportInfo.deviceName = row.deviceName
      weekReportInfo.chargedah = '--'
      weekReportInfo.usedah = '--'
      weekReportInfo.warningAccount = '--'

      sessionStorage.setItem('weekReportInfo', JSON.stringify(weekReportInfo))

      var routeData = this.$router.resolve({
        path: '/report/reportDetail?type=' + type + '&mcuId=' + row.mcuId + '&sn=' + row.deviceSn
      })
      window.open(routeData.href, '_self')
    },
    createFilter (queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    fetchData () { // 电池型号/品牌/设备类型--下拉框初始化
      this.listLoading = true
      cascader().then((response) => {
        // 绑定设备弹窗--电池型号下拉框
        this.options2 = response.resultModel
      })
      machineTypeList().then(res => { // 类型
        if (res.resultCode == 1001) {
          res.resultModel.forEach(v => {
            this.machineTypeOptions = res.resultModel || []
          })
        }
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    closePop (val) { // 新增设备/编辑配置弹窗--右上角的取消按钮
      this.addDevicePop = this.showBatteryModel = false
      this.addBasicinfo = {}
      for (var attr in this.editBasicinfo) this.editBasicinfo[attr] = ''
      if (val == 'editDevicePop') this.editDevicePop = false
      if (val == 'editDevicePop') {
        this.selectRow = {}
      }
    },
    closePopClick () { // 关闭编辑配置弹窗
      this.showBatteryModel = this.editDevicePop = false
      for (var attr in this.editBasicinfo) this.editBasicinfo[attr] = ''
      this.selectRow = {}
    },
    closeAddPopClick (activeDeviceType) { // 关闭新增设备弹窗
      this.showBatteryModel = this.addDevicePop = false
      for (var attr in this.addBasicinfo) this.addBasicinfo[attr] = ''
      switch (activeDeviceType) {
        case 'a': this.yhubQueryList(); break
        case 'e': this.lithiumQueryList(); break
        case 'c': this.controllerQueryList(); break
        case 'i': this.eveBmsQueryList(); break
        case 'j': this.eveF477QueryList(); break
      }
    },
    openRestorePop () { // 打开重置弹窗
      this.restoreFactorySetPop = true
    },
    blurPasscode () { // 恢复出厂设置弹窗--pc码输入失焦
      if (this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = false
      } else {
        this.isShowResFacSetInfoPasscode = true
      }
    },
    submitRestoreFactorySet () { // 恢复出厂设置弹窗--提交
      if (!this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = true
        return
      }
      this.$confirm(this.$t('allDeviceDetail.confirmReset'), '', {// '是否恢复出厂设置?'
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          mcuId: this.selectRow.mcuId,
          pc: this.restoreFactorySetInfo.passcode
        }
        // console.log(param)
        addDeviceAllReset(param).then((res) => {
          if (res.resultCode == 1001) {
            this.restoreFactorySetPop = this.addDevicePop = false
            this.$message({
              type: 'success',
              message: this.$t('allDeviceDetail.resetSucceed') // '重置成功!'
            })
            this.yhubEdit(this.selectRow)
          } else {
            if (res.resultMessage == 'pc error' || res.resultMessage == 'pc null') {
              this.$message({
                type: 'error',
                message: this.$t('BondOrUpdateDevice.IncorrectPasscode') // '重置失败!'
              })
            } else {
              this.$message({
                type: 'error',
                message: this.$t('allDeviceDetail.resetFailed') // '重置失败!'
              })
            }
          }
        })
      }).catch(() => { })
    },
    openConfigStatuPop (nowAndNewConfigData) { // 当前配置和待更改配置弹窗--打开
      this.configStatuPop = true
      this.nowAndNewConfigData = nowAndNewConfigData
    },
    goToSocDetail (row) { // 去soc折线图页
      var routeData, lastUpdateTime
      if (this.activeDevice == 'Yhub') {
        if (row.lastRecordData && row.lastRecordData.yhubStimeTs) {
          lastUpdateTime = row.lastRecordData.yhubStimeTs
        } else {
          lastUpdateTime = Date.parse(new Date())
        }
      } else if (this.activeDevice == 'Lithium') {
        if (row.lastRecordData && row.lastRecordData.yhubTime) {
          lastUpdateTime = row.lastRecordData.yhubTime
        } else {
          lastUpdateTime = Date.parse(new Date())
        }
      }
      routeData = this.$router.resolve({
        path: '/allDevices/socDetailChart',
        query: {
          mcuId: row.mcuId,
          deviceName: row.deviceName,
          // startTime: lastUpdateTime - 1000 * 60 * 60 * 24 * 7,
          lastUpdateTime: lastUpdateTime,
          deviceType: this.activeDevice
        }
      })
      window.open(routeData.href, '_self')
    },
    goToReport (row) { // 去报表页
      var routeData, lastUpdateTime
      if (this.activeDevice == 'Yhub') {
        if (row.lastRecordData && row.lastRecordData.yhubStimeTs) {
          lastUpdateTime = row.lastRecordData.yhubStimeTs
        } else {
          lastUpdateTime = Date.parse(new Date())
        }
        routeData = this.$router.resolve({
          path: '/allDevices/yhubReport',
          query: {
            mcuId: row.mcuId,
            latest: lastUpdateTime
          }
        })
        window.open(routeData.href, '_self')
      } else if (this.activeDevice == 'Lithium') {
        if (row.lastRecordData && row.lastRecordData.yhubTime) {
          lastUpdateTime = row.lastRecordData.yhubTime
        } else {
          lastUpdateTime = Date.parse(new Date())
        }
        routeData = this.$router.resolve({
          path: '/allDevices/lithiumChartPage',
          query: {
            mcuId: row.mcuId,
            deviceName: row.deviceName,
            endTime: lastUpdateTime,
            sn: row.deviceSn
          }
        })
        window.open(routeData.href, '_self')
      }
    },
    goToBleYhub (row) { // 去蓝牙YHUB页
      var routeData = this.$router.resolve({
        path: '/blueTooth/yhubDataDetail',
        query: {
          mcuId: row.mcuId
        }
      })
      window.open(routeData.href, '_self')
    },
    // 分页----start
    handleSizeChange1 (val, e) {
      this.tableStyle = {
        paddingTop: '300px',
        top: '0px'
      }
      this.$refs.TableWarpBox.scrollTo(0, 300)
      this.listQuery1.pageInfo.pageSize = val
      this.yhubQueryList()
    },
    handleCurrentChange1 (val, e) {
      this.tableStyle = {
        paddingTop: '300px',
        top: '0px'
      }
      this.$refs.TableWarpBox.scrollTo(0, 300)
      this.listQuery1.pageInfo.pageNum = val
      this.yhubQueryList()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.lithiumQueryList()
    },
    handleCurrentChange2 (val, e) {
      // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.lithiumQueryList()
    },
    // 分页----end
    // 分页----start
    handleSizeChange3 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery3.pageInfo.pageSize = val
      this.controllerQueryList()
    },
    handleCurrentChange3 (val, e) {
      // 选中某一页
      this.listQuery3.pageInfo.pageNum = val
      this.controllerQueryList()
    },
    // 分页----start
    handleSizeChange4 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery4.pageInfo.pageSize = val
      this.eveBmsQueryList()
    },
    handleCurrentChange4 (val, e) {
      // 选中某一页
      this.listQuery4.pageInfo.pageNum = val
      this.eveBmsQueryList()
    },
    // 分页----start
    handleSizeChange5 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery5.pageInfo.pageSize = val
      this.eveF477QueryList()
    },
    handleCurrentChange5 (val, e) {
      // 选中某一页
      this.listQuery5.pageInfo.pageNum = val
      this.eveF477QueryList()
    },
    download () {
      download263()
    },
    calibrationClick (obj) { // 点击校准后获取数据
      this.isShowCalibration = true
      for (var attr in obj) {
        this.calObj[attr] = obj[attr]
      }
      this.calObj.newVal = null
      this.calObj.chargedahNew = this.calObj.usedahNew = this.calObj.chargingWhNew = this.calObj.usingWhNew = null
      if (!this.$store.state.isAdmin) {
        this.calObj.chargingWhNew = this.calObj.obj.chargingWh
        this.calObj.usingWhNew = this.calObj.obj.usingWh
      }
      if (this.calObj.key == 'current' || this.calObj.key == 'auxCurrent') {
        this.calObj.newVal = 0
      }
    },
    calSubmit () { // 提交校准
      var param = {
        'cmd': 5,
        'mcuId': this.selectRow.mcuId,
        'value': this.calObj.newVal
      }
      // 1 重启设备，3 设置soc，4 设置soh，5 删除所有数据，6 控制继电器，7 ch1电流置零，8 电压设置，9 设置updateindex，10 设置充电/放电电量和能量，11 ch2电流置零，12 aux电压设置
      switch (this.calObj.key) {
        case 'soc': param.cmd = 3; break
        case 'soh': param.cmd = 4; break
        case 'relayStatus': {
          param.cmd = 6
          if (this.calObj.newVal == 0) param.value = false
          if (this.calObj.newVal == 1) {
            param.value = true + ',' + Math.round(this.calObj.popStartDate / 1000) + ',' + Math.round(this.calObj.popEndDate / 1000)
          }
          break
        }
        case 'voltageRaw': param.cmd = 8; break
        case 'updateIndex': param.cmd = 9; break
        case 'auxCurrent': param.cmd = 11; break
        case 'auxBatVol': param.cmd = 12; break
      }
      if (this.calObj.key == 'chargedah' || this.calObj.key == 'usedah' || this.calObj.key == 'chargingWh' || this.calObj.key == 'usingWh') {
        param.cmd = 10
        param.value = this.calObj.chargedahNew + ',' + this.calObj.usedahNew + ',' + this.calObj.chargingWhNew + ',' + this.calObj.usingWhNew
      }
      console.log('param-------', param)
      if (this.calObj.key == 'updateIndex') {
        this.$confirm(this.$t('AllDevices.ConfirmReset'), '', {// '确实重新设置ID吗？'
          confirmButtonText: this.$t('button.Confirm'), // '确定'
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          this.yhubControl(param)
        }).catch(() => { })
      } else {
        this.yhubControl(param)
      }
    },
    yhubControl (param) { // 提交校准2
      yhubControl(param).then(res => {
        if (res.resultCode == 1001) {
          this.$message({
            type: 'success',
            message: this.$t('AllDevices.submitP')
          })
          this.isShowCalibration = false
          var param = {
            companyIdList: this.selectCompany,
            key: this.selectRow.mcuId,
            displayTime: new Date().setHours(0, 0, 0, 0) // 当天零点的时间戳
            // pageNum: this.listQuery2.pageInfo.pageNum, // 分页--选中某一页
            // pageSize: this.listQuery2.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
          }
          if (this.activeDevice == 'Yhub') {
            param.pageNum = this.listQuery1.pageInfo.pageNum
            param.pageSize = this.listQuery1.pageInfo.pageSize
            findBatteryDeviceList(param).then((response) => {
              if (response.resultCode == 1001) {
                this.lastRecordData = response.resultModel.list[0].lastRecordData
              }
            })
          } else if (this.activeDevice == 'Lithium') {
            param.pageNum = this.listQuery2.pageInfo.pageNum
            param.pageSize = this.listQuery2.pageInfo.pageSize
            findLithiumDeviceList(param).then((response) => {
              if (response.resultCode == 1001) {
                this.lastRecordData = response.resultModel.list[0].lastRecordData
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.resultMessage
          })
        }
      })
    },
    getCity () { // 获取已有的地址
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    querySearchCity (queryString, cb) { // 获取已有的地址2
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    existsOrZero (val) { // 存在或为零则为ture
      if (val && typeof (val) === 'string') val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (val === '') {
        return false
      } else if (val || val == 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.allDeviceIndex {
  position: relative;
  height: 100%;

  .myTable {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #e6e9ed;
    font-size: 14px;
    color: #606266;
    th {
      color: #909399;
      padding: 0 10px;
    }
    td {
      text-align: center;
      padding: 10px;
      position: relative;
    }
    .infoP {
      font-weight: bold;
    }
  }
}
.headChartWarp {
  padding-right: 20px;
}
.tableWarp {
  background-color: #fff;
  position: absolute;
  top: 300px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  overflow-y: scroll;
}
.table_box {
  padding: 10px 20px;
}
.input_list {
  background-color: #fff;
  padding: 10px 20px;
  left: 0;
  width: 100%;
  z-index: 1002;
}

// 校准弹窗
.chargeDisBox {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
  padding: 15px;
  .attr {
    margin-bottom: 0px !important;
  }
}
.chargeDisWarp {
  display: inline !important;
  .btnWarp {
    text-align: right;
    margin-top: 20px;
    position: relative;
    z-index: 9999;
  }
}

.status_icon_box {
  // position: absolute;
  // left: 5px;
  // top: 5px;
  margin-bottom: 6px;
  i {
    font-size: 18px;
    color: #666;
    margin: 0 8px;
  }
  i.active {
    color: #7cb329;
  }
  i.offline {
    color: #f00;
  }
}

// 排序三角形
.sortArrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  width: 10px;
  cursor: pointer;
}
.topArrow {
  border-bottom: 10px solid #90939985;
}
.bottomArrow {
  border-top: 10px solid #90939985;
  margin-top: 7px;
}
.topArrow.activeArrow {
  border-bottom-color: #1890ff;
}
.bottomArrow.activeArrow {
  border-top-color: #1890ff;
}

.real_item {
  min-width: 300px;
  border-top: none;
  border-left: none;
  border-right: none;
  img {
    width: 26px;
  }
  .soc {
    display: block;
    width: 32px;
    margin: 5px 0;
  }
  p {
    line-height: 24px;
  }
  p:first-of-type {
    font-size: 12px;
    line-height: 20px;
  }
  & > div {
    padding: 0 6px;
  }
}
.btn_box {
  min-width: 120px;
}
.online_tag {
  background-color: #7cb329;
  color: #fff;
  padding: 4px 6px;
  border-radius: 20px;
  font-size: 12px;
  user-select: none;
}
</style>
